import React from 'react';
import { TiInfoLargeOutline } from 'react-icons/ti';
import '../../components/Skills/Skills.scss';
const MoreAbout = () => {
  return (
    <div className=" min-h-screen  h-full bg-gradient-to-tr from-slate-900 to-slate-900 mt-14   p-5 md:px-32 lg:ml-[5rem] ">
      <TiInfoLargeOutline className="fixed text-teal-400 font-outfit opacity-5 text-[13rem]  bottom-0 " />
      <div className=" flex flex-col items-center text-center  gap-5 font-outfit">
        <h1
          bg-text="More Info About Me"
          className="heading__text text-4xl text-teal-400 font-semibold "
        >
          More Info About Me
        </h1>
        <p className="text-teal-200 brightness-125 text-lg tracking-wider">
          I'm a Front End Web developer (which you probably already know from
          the BIG cool home page text) based in Chattagram, Bangladesh .
        </p>
        <p className="text-teal-200 brightness-125 text-lg tracking-wider">
          Web developement is something that I love doing .
        </p>
        <h1 className=" tracking-wider text-3xl text-teal-400 font-semibold ">
          Education
        </h1>
        <p className="text-teal-200 brightness-125 text-lg tracking-wider">
          4 years Diploma in Computer Technology from Chattagram Polytechnic
          Institute
        </p>
        <h1 className=" tracking-wider text-3xl text-teal-400 font-semibold ">
          Work Experience
        </h1>{' '}
        <p className="text-teal-200 brightness-125 text-lg tracking-wider">
          AppNext IT - Intern Web Developer (2022 October - 2023 January)
        </p>
        <h1 className="text-3xl text-teal-400 font-semibold ">Random Info</h1>
        <p className="text-teal-200 brightness-125 text-lg tracking-wider">
          I love learning. Everyday, I try to make myself better then the
          previous day.
        </p>
      </div>
    </div>
  );
};

export default MoreAbout;
